module.exports = __webpack_public_path__ + "static/media/Questions.69e5cffc.gif";